var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          title: _vm.$t("pages.admin.messages.title"),
          "icon-class": "mdi mdi-telegram"
        }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "alert alert-secondary border-dark shadow-sm",
        domProps: {
          innerHTML: _vm._s(_vm.$t("pages.admin.messages.explanation"))
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "card shadow-sm" }, [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("strong", [_vm._v(_vm._s(_vm.$t("pages.admin.messages.type")))]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm",
                  class: [
                    _vm.type === "info" ? "btn-info" : "btn-outline-info"
                  ],
                  on: {
                    click: function($event) {
                      _vm.type = "info"
                    }
                  }
                },
                [
                  _c("i", { staticClass: "mdi mdi-information" }),
                  _c("br"),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("pages.admin.messages.types.info")) +
                      "\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm",
                  class: [
                    _vm.type === "success"
                      ? "btn-success"
                      : "btn-outline-success"
                  ],
                  on: {
                    click: function($event) {
                      _vm.type = "success"
                    }
                  }
                },
                [
                  _c("i", { staticClass: "mdi mdi-check" }),
                  _c("br"),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("pages.admin.messages.types.success")) +
                      "\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm",
                  class: [
                    _vm.type === "warning"
                      ? "btn-warning"
                      : "btn-outline-warning"
                  ],
                  on: {
                    click: function($event) {
                      _vm.type = "warning"
                    }
                  }
                },
                [
                  _c("i", { staticClass: "mdi mdi-alert" }),
                  _c("br"),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("pages.admin.messages.types.warning")) +
                      "\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm",
                  class: [
                    _vm.type === "danger" ? "btn-danger" : "btn-outline-danger"
                  ],
                  on: {
                    click: function($event) {
                      _vm.type = "danger"
                    }
                  }
                },
                [
                  _c("i", { staticClass: "mdi mdi-alert-octagon" }),
                  _c("br"),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("pages.admin.messages.types.danger")) +
                      "\n                    "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              { staticClass: "font-weight-bold", attrs: { for: "title" } },
              [_vm._v(_vm._s(_vm.$t("pages.admin.messages.your_title")))]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.title,
                  expression: "title"
                }
              ],
              staticClass: "form-control",
              attrs: {
                id: "title",
                type: "text",
                placeholder: _vm.$t("pages.admin.messages.your_title")
              },
              domProps: { value: _vm.title },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.title = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              { staticClass: "font-weight-bold", attrs: { for: "message" } },
              [_vm._v(_vm._s(_vm.$t("pages.admin.messages.your_message")))]
            ),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.message,
                  expression: "message"
                }
              ],
              staticClass: "form-control",
              attrs: {
                id: "message",
                cols: "30",
                rows: "10",
                placeholder: _vm.$t("pages.admin.messages.your_message")
              },
              domProps: { value: _vm.message },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.message = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary mt-4",
              on: { click: _vm.sendMessage }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("pages.admin.messages.send")) +
                  "\n            "
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }